import { useMemo } from 'react';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PayBenchmarkingCompensationUnit } from 'libs/end-to-end/src/pay-benchmarking';
import { PayBenchmarkingRequest } from 'libs/end-to-end/src/custom-viz/PayBenchmarkingTypes';
import { constructPayBenchmarkingRequest } from 'apps/sigma2-ui/src/lib/custom-viz/construct-pay-benchmarking-request';

export const usePayBenchmarkingCurrentCustomVizRequestToExecute = ({
  organizationId,
  observation,
  selectedBenchmark,
  selectedCompensationUnit,
  selectedCurrency,
  selectedDepartment,
  selectedEducationLabel,
  selectedExperience,
  selectedLevel,
  selectedLocation,
  selectedRole,
}: {
  organizationId: string;
  observation: ObservationLocationType;
  selectedBenchmark: string | null;
  selectedCompensationUnit: PayBenchmarkingCompensationUnit;
  selectedCurrency: string | null;
  selectedDepartment: string | null;
  selectedEducationLabel: string | null;
  selectedExperience: string | null;
  selectedLevel: string | null;
  selectedLocation: string | null;
  selectedRole: string | null;
}): PayBenchmarkingRequest | null => {
  return useMemo(() => {
    if (
      !selectedDepartment ||
      !selectedRole ||
      !selectedLevel ||
      !selectedLocation ||
      !selectedExperience ||
      !selectedEducationLabel ||
      !selectedCurrency ||
      !selectedBenchmark
    ) {
      return null;
    }

    return constructPayBenchmarkingRequest({
      benchmark: selectedBenchmark,
      department: selectedDepartment,
      role: selectedRole,
      level: selectedLevel,
      location: selectedLocation,
      experience: selectedExperience,
      education: selectedEducationLabel,
      currency: selectedCurrency,
      compensationUnit: selectedCompensationUnit,
      organizationId,
      observationLocationType: observation,
    });
  }, [
    organizationId,
    selectedBenchmark,
    selectedDepartment,
    selectedRole,
    selectedLevel,
    selectedLocation,
    selectedExperience,
    selectedEducationLabel,
    selectedCurrency,
    selectedCompensationUnit,
    observation,
  ]);
};
